import React, { useEffect, useState } from 'react'
import { AnimatePresence, delay, motion } from 'framer-motion';
import useStore from './store';


var c = 0;

const Into = () => {
    const incr = useStore((state) => state.inc);
    const coun = useStore((state) => state.count1);

    const [count, setCount] = useState(false);

    useEffect(() => {
        var elem = document.getElementById("myBar");
        var width = 1;



        const Interval = setInterval(() => {
            if (c >= 100)
                return;
            c++;
            incr();
            console.log(coun);
            elem.style.width = (c) + '%';
            setCount(c);
        }, 20);


        const Interval1 = setInterval(() => {
            if (c >= 106)
                return clearInterval(Interval);
            c++;
            incr();
            // console.log(coun);
            // elem.style.width = (c) + '%';
            // setCount(c);
        }, 270);
        

    }, [])

   

    return (
        // <AnimatePresence>
        <div>


          {/* <motion.div key="pop"
          
                exit={{ opacity: 0 }}
                initial={{  opacity: 1  }}
                animate={count === 100 ? { opacity: 0, display: "none" } : " "}
                transition={{ duration: 3 }}
               
                
            
            > */}

                <div className='flex min-h-screen w-full bg-white-300 flex-col justify-between    '>
                    <div className=' pt-5 pl-5 min-w-full'>
                        <p className='league-spartan-extrabold tracking-wider text-3xl'>hemil .</p>
                    </div>
                    <div>

                        <div className=' pb-5 pl-5 pr-5 flex justify-between justify-self-end'>
                            <div className=' place-self-center'>
                                <p className='text-md  md:text-4xl'>I develop User-Centric Projects</p>
                                <p className=' text-gray-400'>Loading..</p>

                            </div>
                            <div className=' justify-self-end'>
                                <p className='league-spartan-extrabold text-8xl' id="per"> {count > 100 ? "100" : count}% </p>
                            </div>

                        </div>
                        <div className=''>
                            <p id='myBar' className={`league-spartan-extrabold text-3xl text-center bg-black h-4  rounded-sm `}></p>
                        </div>
                    </div>


                </div>
                </div>

          
     )
}


export default Into